import { get, post } from '.';

export function CreateUserClientDrop(options = {}) {
	return post<any>("/app/api/user_client_drops", options);
}

export function GetUserClientDrops(options = {}) {
	return get<any>("/app/api/user_client_drops", options);
}